export default {
  props: {
    mandatoryDimension: {
      type: String,
      required: false,
    },
    isInitialArticle: {
      type: Boolean,
      required: true,
    },
    idChain: {
      type: Object,
      required: false,
    },
  },
  methods: {
    catchIncompleteDataClick(e) {
      // catch click and present color selector if none is selected
      if (this.isInitialArticle && this.mandatoryDimension === 'farben') {
        e.preventDefault();
        e.stopPropagation();

        this.$parent.$emit('bewerten:vue:dimension:select', { dimension: 'farben' });
      }
    },
  },
};
